/// <amd-module name="Build/Common/Commands/confirmpipelineaction/Command" />
import * as React from "react";

import { IConfirmPipelineActionProps } from "Build/Common/Commands/confirmpipelineaction/Command.types";

import { Dialog } from "VSSUI/Dialog";
import { TitleSize } from "VSSUI/Header";

import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";

import * as Resources from "Build/Common/Commands/Resources";

class ConfirmPipelineAction extends VssComponent<IConfirmPipelineActionProps> {
    public static componentType = "ciDConfirmPipelineComponent";

    constructor(props: IConfirmPipelineActionProps) {
        super(props);
    }

    public render() {
        return (
            <Dialog
                calloutContentClassName="ci-dialog"
                onDismiss={this._onDismiss}
                showCloseButton={true}
                footerButtonProps={[
                    {
                        onClick: this._onDismiss,
                        text: this.props.cancelLabel || Resources.No
                    },
                    {
                        onClick: this._onCommit,
                        primary: !this.props.isDanger,
                        danger: this.props.isDanger,
                        text: this.props.confirmLabel || Resources.Yes
                    }
                ]}
                titleProps={{ text: this.props.title, size: TitleSize.Large}}>
                <div>{this.props.message}</div>
            </Dialog>
        );
    }

    private _onCommit = () => {
        this.props.onClose();
        this.props.onConfirm();
    }

    private _onDismiss = () => {
        this.props.onClose();
    }

}

VssComponent.register(ConfirmPipelineAction.componentType, ConfirmPipelineAction as React.ComponentClass<IVssComponentProperties>);
